import React from 'react';
import { Link } from 'react-router-dom';
import { AccountData } from '../../api';
import { optimizeImageUrl } from '../../utils/orderPageImageUtils';

type AccountLogoProps = {
  account: Pick<AccountData, 'logo' | 'name'> | undefined | null;
  // Max pixel width used to request a scaled image from Bytescale. Display sizing is
  // controlled separately via `style` so callers can keep their existing layout.
  width: number;
  style?: React.CSSProperties;
  linkTo?: string;
  alt?: string;
};

export const AccountLogo: React.FC<AccountLogoProps> = ({ account, width, style, linkTo, alt }) => {
  if (!account?.logo) return null;
  const src = optimizeImageUrl(account.logo, width);
  const img = <img src={src} alt={alt ?? account.name} style={style} />;
  return linkTo ? <Link to={linkTo}>{img}</Link> : img;
};
